import Swiper from 'swiper';
import SwiperCore, { Navigation, Scrollbar } from 'swiper/core';
import 'swiper/css';
SwiperCore.use([Navigation, Scrollbar]);


export default class Testimonials extends HTMLElement {
    /**
     * Class constructor
    */
    constructor() {
        super();
        this.el = this;
        this.carousel = this.querySelector('.swiper');
        this.sliderWrapper = this.el.querySelector('.swiper-wrapper');
        this.sliderSlides = this.el.querySelectorAll('.swiper-slide');
        this.arrowNext = this.el.querySelector('.swiper-button-next');
        this.arrowPrev = this.el.querySelector('.swiper-button-prev');
        this.scrollbar = this.el.querySelector('.swiper-scrollbar');

        this.init()
    }

    init() {
        this.createSwiper()
    }

    createSwiper() {
        this.swiper = new Swiper(this.carousel, {
            slidesPerView: 1,
            spaceBetween: 20,
            watchOverflow: true,
            threshold: 10,
            navigation: {
                nextEl: this.arrowNext,
                prevEl: this.arrowPrev
            },
            scrollbar: {
                el: this.scrollbar,
                draggable: true,
                hide: false
            },
            breakpoints: {
                768: {
                    slidesPerView: 2
                },
                1024: {
                    slidesPerView: 3
                }
            }
        });
    }
}

customElements.define('testimonials-carousel', Testimonials);